// extracted by mini-css-extract-plugin
module.exports = {"layout":"_1410bfd27b--layout--dVaQU","spinner":"_1410bfd27b--spinner--e_O7D","container":"_1410bfd27b--container--M0xiL","error":"_1410bfd27b--error--AcAkz"};